import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Language from '../Language/index';
import HeaderLogin from '../HeaderLogin/index';

const Header = ({ t, i18n }) => {
  return <Fragment>
    <div className='row'>
      <div className='col no-padding'>
        <div className='header'>
          <div className='logo'></div>
          <div className='right'>
            <Language i18n={i18n} />
            <HeaderLogin t={t} />
          </div>
        </div>
      </div>
    </div>
  </Fragment>;
};

Header.propTypes = {
  t: PropTypes.func,
  i18n: PropTypes.object
};

export default Header;
